const mod = require('../../bahabot.module.js')


function bbDocsController() {

}

mod.component('bbDocs', {
    templateUrl: 'tpl/bb-docs.component.html',
    bindings: {},
    controller: [bbDocsController]
});